/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

import {WebexPlugin} from '@webex/webex-core';
import {defaults} from 'lodash';
import uuid from 'uuid';

const Support = WebexPlugin.extend({
  namespace: 'Support',

  getFeedbackUrl(options) {
    options = options || {};

    return this.request({
      method: 'POST',
      api: 'conversation',
      resource: 'users/deskFeedbackUrl',
      body: defaults(options, {
        appVersion: this.config.appVersion,
        appType: this.config.appType,
        feedbackId: options.feedbackId || uuid.v4(),
        languageCode: this.config.languageCode
      })
    })
      .then((res) => res.body.url);
  },

  getSupportUrl() {
    return this.webex.request({
      method: 'GET',
      api: 'conversation',
      resource: 'users/deskSupportUrl',
      qs: {
        languageCode: this.config.languageCode
      }
    })
      .then((res) => res.body.url);
  },

  submitLogs(metadata, logs) {
    const metadataArray = this._constructFileMetadata(metadata);

    // this is really testing that Ampersand is fully ready.  once it's ready, these exist
    if (!logs && this.webex.logger.sdkBuffer && this.webex.logger.clientBuffer && this.webex.logger.buffer) {
      logs = this.webex.logger.formatLogs();
    }

    let filename;

    if (metadata.locusId && metadata.callStart) {
      filename = `${metadata.locusId}_${metadata.callStart}.txt`;
    }
    else {
      filename = `${this.webex.sessionId}.txt`;
    }

    let userId;

    return this.webex.credentials.getUserToken()
      .catch(() => this.webex.credentials.getClientToken())
      .then(async (token) => {
        const headers = {authorization: token.toString()};

        const initalOpts = {
          service: 'clientLogs',
          resource: 'logs/urls'
        };

        const finalOpts = {
          service: 'clientLogs',
          resource: 'logs/meta'
        };

        const options = defaults(initalOpts, {
          file: logs,
          shouldAttemptReauth: false,
          headers,
          phases: {
            initialize: {
              body: {
                file: filename
              }
            },
            upload: {
              $uri: (session) => session.tempURL
            },
            finalize: defaults(finalOpts, {
              $body: (session) => {
                userId = session.userId;

                return {
                  filename: session.logFilename,
                  data: metadataArray,
                  userId: this.webex.internal.device.userId || session.userId
                };
              }
            })
          }
        });

        return this.webex.upload(options);
      })
      .then((body) => {
        if (userId && !body.userId) {
          body.userId = userId;
        }

        return body;
      });
  },

  _constructFileMetadata(metadata) {
    const metadataArray = [
      'locusId',
      'callStart',
      'feedbackId',
      'correlationId',
      'meetingId'
    ].map((key) => {
      if (metadata[key]) {
        return {
          key,
          value: metadata[key]
        };
      }

      return null;
    })
      .filter((entry) => Boolean(entry));

    if (this.webex.sessionId) {
      metadataArray.push({
        key: 'trackingId',
        value: this.webex.sessionId
      });
    }

    if (this.webex.internal.device.userId) {
      metadataArray.push({
        key: 'userId',
        value: this.webex.internal.device.userId
      });
    }

    if (this.webex.internal.device.orgId) {
      metadataArray.push({
        key: 'orgId',
        value: this.webex.internal.device.orgId
      });
    }

    return metadataArray;
  }
});

export default Support;
